module.exports = __webpack_public_path__ + "src/assets/textures/molar/molar_scene_uv_norm_phong78_Normal.jpg";